import { type WidgetSetting } from "@repo/api";

import { getCoworkerSettingsValue } from "../../customize/settings/CoworkerSettingsControl";

export const getWorkOrderWidgetSettings = (settings?: WidgetSetting) => {
  const { email, teamId, assignedToTeam } = getCoworkerSettingsValue(
    settings?.["COWORKER"]?.toString() ?? ""
  );

  const unitIds = settings?.STORE
    ? Array.isArray(settings.STORE)
      ? settings.STORE
      : [settings.STORE]
    : undefined;

  const resolvedEmail = email?.length > 0 ? email : undefined;

  return {
    unitIds,
    coworkerFilter: resolvedEmail,
    teamsFilter: teamId,
    assignedToTeam,
    status: settings?.status ?? [],
    installQuoteValueFilter: settings?.quotationValue ?? [],
    docusignDateSentFilter: settings?.docusignDateSentFilter,
    installationFromDateFilter: settings?.installationFromDateFilter,

    depositPaid: settings?.depositPaid ?? undefined,
  };
};
